import { useState } from 'react'

import { BalanceAlias } from '@/api/models/finance'
import { usePaymentDetail } from '@/api/models/finance/hooks/usePaymentDetail'
import { RequestByIdApiType } from '@/api/models/requests'
import { Payment } from '@/components/pages/bill/ui/sc/InvoicesDrawer/Payment/Payment'
import { ErrorModal } from '@/components/shared/modal/ui/ErrorModal'

type Props = {
  request?: RequestByIdApiType
  invoiceId?: string
  personalAccountId?: string
  onClose: () => void
  returnBackUrl?: string
}

export const RequestPaymentForm = ({
  request,
  invoiceId,
  personalAccountId,
  onClose,
  returnBackUrl
}: Props) => {
  const [isErrorModalShowing, setIsErrorModalShowing] = useState(false)

  const resolvedPersonalAccountId =
    request?.personalAccountId || personalAccountId
  const resolvedInvoiceId = request?.invoiceId || invoiceId

  const {
    data: payment,
    isLoading: isPaymentLoading,
    errorStatus
  } = usePaymentDetail({
    alias: BalanceAlias.ComplementaryServices,
    personalAccountId: resolvedPersonalAccountId,
    invoiceId: resolvedInvoiceId,
    enabled: Boolean(resolvedPersonalAccountId) && Boolean(resolvedInvoiceId)
  })

  return (
    <>
      <Payment
        returnBackUrl={returnBackUrl}
        balanceAlias={BalanceAlias.ComplementaryServices}
        showErrorModal={() => setIsErrorModalShowing(true)}
        onBackClick={onClose}
        paymentDetail={{ payment, isLoading: isPaymentLoading, errorStatus }}
      />
      <ErrorModal
        headerText="Оплата недоступна"
        text="Оплата банковской картой в настоящий момент недоступна. Попробуйте
        другой способ оплаты или повторите попытку позже."
        opened={isErrorModalShowing}
        onClose={() => {
          onClose()
          setIsErrorModalShowing(false)
        }}
      />
    </>
  )
}
